var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgSuccessfulGreen400212X237(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 213,
    viewBox: "0 0 237 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1799 105.637L144.582 41.6924L33.1799 105.637Z",
    fill: "#67C174"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.459 34.8753C160.228 41.4284 157.965 49.7931 151.406 53.5582L40.004 117.502C33.4444 121.268 25.0716 119.008 21.3027 112.454C17.5338 105.901 19.7961 97.5367 26.3557 93.7715L137.757 29.8273C144.317 26.0621 152.69 28.3222 156.459 34.8753Z",
    fill: "#67C174"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6787 147.576L171.081 83.6318L59.6787 147.576Z",
    fill: "#67C174"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.958 76.8147C186.726 83.3679 184.464 91.7325 177.905 95.4977L66.5028 159.442C59.9432 163.207 51.5703 160.947 47.8015 154.394C44.0326 147.841 46.2949 139.476 52.8545 135.711L164.256 71.7667C170.816 68.0015 179.189 70.2616 182.958 76.8147Z",
    fill: "#67C174"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.616 67.5629L208.298 62.5137L199.616 67.5629Z",
    fill: "#67C174"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.136 55.6293C223.942 62.161 221.728 70.5383 215.189 74.3406L206.507 79.3899C199.969 83.1921 191.584 80.9795 187.778 74.4479C183.972 67.9162 186.186 59.5389 192.724 55.7366L201.407 50.6873C207.945 46.885 216.33 49.0976 220.136 55.6293Z",
    fill: "#67C174"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.9805 182.08L183.586 132.711L98.9805 182.08Z",
    fill: "#67C174"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.414 125.809C199.229 132.335 197.027 140.716 190.494 144.528L105.889 193.897C99.3565 197.709 90.9677 195.508 87.1521 188.982C83.3365 182.456 85.539 174.076 92.0715 170.264L176.677 120.895C183.209 117.083 191.598 119.283 195.414 125.809Z",
    fill: "#67C174"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.214 138.169C203.21 138.064 202.308 138.793 202.203 139.797C202.097 140.801 202.827 141.702 203.832 141.808C204.836 141.913 205.738 141.184 205.843 140.18C205.949 139.176 205.219 138.275 204.214 138.169ZM200.934 139.664C201.113 137.96 202.643 136.723 204.347 136.902C206.052 137.081 207.291 138.609 207.112 140.313C206.932 142.017 205.403 143.254 203.699 143.075C201.994 142.896 200.755 141.368 200.934 139.664Z",
    fill: "#67C174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1538 188.782C58.502 188.609 57.019 189.809 56.8452 191.46C56.6714 193.11 57.8721 194.592 59.5238 194.765C61.1756 194.939 62.6587 193.738 62.8324 192.088C63.0062 190.437 61.8056 188.955 60.1538 188.782ZM54.7598 191.241C55.0548 188.439 57.5697 186.404 60.3732 186.698C63.1768 186.992 65.2128 189.505 64.9179 192.307C64.6229 195.108 62.1079 197.144 59.3044 196.849C56.5009 196.555 54.4648 194.043 54.7598 191.241Z",
    fill: "#67C174"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.071 22.5623C115.42 22.389 113.936 23.5892 113.763 25.2399C113.589 26.8906 114.79 28.3724 116.441 28.5457C118.093 28.719 119.576 27.5187 119.75 25.868C119.924 24.2173 118.723 22.7355 117.071 22.5623ZM111.677 25.0211C111.972 22.2194 114.487 20.184 117.291 20.4782C120.094 20.7723 122.13 23.2851 121.835 26.0868C121.54 28.8885 119.025 30.9239 116.222 30.6297C113.418 30.3356 111.382 27.8228 111.677 25.0211Z",
    fill: "#67C174"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1364 75.0979C22.5362 75.0979 22.0484 75.5853 22.0484 76.1848C22.0484 76.7844 22.5362 77.2717 23.1364 77.2717C23.7365 77.2717 24.2243 76.7844 24.2243 76.1848C24.2243 75.5853 23.7365 75.0979 23.1364 75.0979ZM20.5154 76.1848C20.5154 74.7394 21.6895 73.5664 23.1364 73.5664C24.5832 73.5664 25.7574 74.7394 25.7574 76.1848C25.7574 77.6302 24.5832 78.8032 23.1364 78.8032C21.6895 78.8032 20.5154 77.6302 20.5154 76.1848Z",
    fill: "#67C174"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.172 195.912C166.571 195.912 166.084 196.4 166.084 196.999C166.084 197.599 166.571 198.086 167.172 198.086C167.772 198.086 168.259 197.599 168.259 196.999C168.259 196.4 167.772 195.912 167.172 195.912ZM164.551 196.999C164.551 195.554 165.725 194.381 167.172 194.381C168.618 194.381 169.793 195.554 169.793 196.999C169.793 198.445 168.618 199.618 167.172 199.618C165.725 199.618 164.551 198.445 164.551 196.999Z",
    fill: "#67C174"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.963 13.9823L188.663 21.0548L187.814 20.7793L190.114 13.7068L190.963 13.9823Z",
    fill: "#67C174"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.906 19.008L185.828 16.7106L186.104 15.8613L193.183 18.1587L192.906 19.008Z",
    fill: "#67C174"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0416 135.289L30.9893 142.437L30.1313 142.191L32.1836 135.043L33.0416 135.289Z",
    fill: "#67C174"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1591 140.243L28.0043 138.193L28.2507 137.335L35.4056 139.384L35.1591 140.243Z",
    fill: "#67C174"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.384 167.341L185.709 174.587L184.84 174.387L186.515 167.141L187.384 167.341Z",
    fill: "#67C174"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.758 172.179L182.506 170.507L182.707 169.637L189.959 171.309L189.758 172.179Z",
    fill: "#67C174"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.533 52.7314C148.07 52.7314 172.052 76.6896 172.052 106.197C172.052 135.705 148.07 159.664 118.533 159.664C88.9961 159.664 65.0144 135.705 65.0144 106.197C65.0144 76.6896 88.9961 52.7314 118.533 52.7314Z",
    fill: "#FFFFFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 57.7881C145.243 57.7881 166.957 79.4803 166.957 106.197C166.957 132.914 145.243 154.607 118.5 154.607C91.7565 154.607 70.043 132.914 70.043 106.197C70.043 79.4803 91.7565 57.7881 118.5 57.7881Z",
    fill: "#67C174"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.278 92.0193L109.738 124.528L94.7432 109.888L98.489 106.059L109.695 116.999L138.489 88.2334L142.278 92.0193Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSuccessfulGreen400212X237);
export default __webpack_public_path__ + "static/media/img_successful_green_400_212x237.37ff6193d188b500597b664bcf85ad09.svg";
export { ForwardRef as ReactComponent };